import { ItemSelectionService } from 'ycharts/static/ts/services/item-selection.service';
import { ContentItemBase } from 'apps/folders/static/directives/content-item-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "ycharts/static/ts/services/item-selection.service";
import * as i2 from "../../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i3 from "../../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i5 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
function FundChartSelectSavedListItemComponent_Conditional_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵelement(4, "div", 5);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 2, folder_r1.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(5, 5, folder_r1));
} }
function FundChartSelectSavedListItemComponent_Conditional_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-fund-chart-select-saved-list-item", 7);
} if (rf & 2) {
    const folderable_r2 = ctx.folderable;
    const ancestorInfo_r3 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r2)("ancestorInfo", ancestorInfo_r3);
} }
function FundChartSelectSavedListItemComponent_Conditional_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span");
    i0.ɵɵtext(2, "There are no fundamental charts in this folder.");
    i0.ɵɵelementEnd()();
} }
function FundChartSelectSavedListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 3);
    i0.ɵɵtemplate(1, FundChartSelectSavedListItemComponent_Conditional_0_ng_template_1_Template, 6, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, FundChartSelectSavedListItemComponent_Conditional_0_ng_template_3_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, FundChartSelectSavedListItemComponent_Conditional_0_ng_template_5_Template, 3, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r4 = i0.ɵɵreference(2);
    const listItemFragment_r5 = i0.ɵɵreference(4);
    const emptyFolderFragment_r6 = i0.ɵɵreference(6);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r6.folderable)("ancestorInfo", ctx_r6.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r4)("listItemFragment", listItemFragment_r5)("emptyFolderFragment", emptyFolderFragment_r6);
} }
function FundChartSelectSavedListItemComponent_Conditional_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "label", 12)(3, "input", 13);
    i0.ɵɵlistener("click", function FundChartSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r8); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.bulkActionSelectionService.toggleSelectedItem(ctx_r6.folderable.resourceType, ctx_r6.fundChart.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵlistener("click", function FundChartSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r8); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.itemSelectionService.selectItem(ctx_r6.fundChart)); });
    i0.ɵɵelementStart(6, "div", 16)(7, "div", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 18);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 19);
    i0.ɵɵtext(10, "fc");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "a", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 4);
    i0.ɵɵelement(13, "div", 5);
    i0.ɵɵpipe(14, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 6);
    i0.ɵɵelement(16, "div", 5);
    i0.ɵɵpipe(17, "getOwnerDisplayName");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r6.isBulkSelected);
    i0.ɵɵproperty("folderable", ctx_r6.folderable)("ancestorInfo", ctx_r6.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r6.isBulkSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r6.isBulkSelected);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r6.fundChart.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(14, 10, ctx_r6.fundChart.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(17, 13, ctx_r6.fundChart));
} }
function FundChartSelectSavedListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FundChartSelectSavedListItemComponent_Conditional_1_Conditional_0_Template, 18, 15, "div", 9);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r6.bulkActionSelectionService.idsByResourceType$) ? 0 : -1);
} }
export class FundChartSelectSavedListItemComponent extends ContentItemBase {
    constructor(itemSelectionService) {
        super();
        this.itemSelectionService = itemSelectionService;
    }
    get fundChart() {
        return this.folderable.item;
    }
    get itemSelectionEnabled() {
        return this.fundChart.permissions?.canView ?? true;
    }
    fileDropdownHandler() { }
}
FundChartSelectSavedListItemComponent.ɵfac = function FundChartSelectSavedListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartSelectSavedListItemComponent)(i0.ɵɵdirectiveInject(i1.ItemSelectionService)); };
FundChartSelectSavedListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartSelectSavedListItemComponent, selectors: [["ycn-fund-chart-select-saved-list-item"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3"], [1, "file-td-wrap", "pt-1", "pb-1", 3, "textContent"], [1, "td", "col-3", "col-md-2"], [3, "folderable", "ancestorInfo"], [1, "get-started-small", "flex-auto"], ["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox", "pt-1", "pb-1"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], ["data-test-id", "fund-chart-saved-list-item", 1, "td", "file-td-name", 3, "click"], [1, "file-name", "file-td-wrap", "pt-1", "pb-1"], [1, "file-icon", "file-fc"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], ["href", "javascript:void(0)", 3, "textContent"]], template: function FundChartSelectSavedListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, FundChartSelectSavedListItemComponent_Conditional_0_Template, 7, 5)(1, FundChartSelectSavedListItemComponent_Conditional_1_Template, 2, 3);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i2.DisabledDirective, i3.IconDirective, i4.FolderableDirective, i5.FolderBaseComponent, FundChartSelectSavedListItemComponent, i6.AsyncPipe, i6.DatePipe, i7.GetOwnerDisplayName], encapsulation: 2, changeDetection: 0 });
